module.exports = __webpack_public_path__ + "img/car_icon15.44fbf4dd.png";